module.exports = __webpack_public_path__ + "static/quiz_stage_5_bg-b7dec0548743d6e26f14bd06d003a2a7.svg";